import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  body,
  html,
  body #root {
    margin: 0;
    padding: 0;
    color: #404040;
    font-weight: 400;
    background-color: #f7f8fb;
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
  }

  a {
    text-decoration: none;
    color: #2f89a0;
  }

  a:hover,
  a:focus {
    text-decoration: none;
    color: #2f89a0;
  }

  form *,
  form .ui.input input {
    font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  ::selection {
    color: #fff;
    background: #333;
    text-shadow: none;
  }

  ::-moz-selection {
    color: #fff;
    background: #333;
    text-shadow: none;
  }

  .content-wrapper {
    width: 100%;
    max-width: 1160px;
    margin: 0 auto;
  }

  .ant-select-dropdown-menu-item-active,
  .ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
    background-color: rgba(70, 103, 237, 0.2) !important;
  }
`;

export default GlobalStyles;
